<template>
  
  <div class="sidebar-container">
        <el-scrollbar style="height: 100%">
          <el-menu router :show-timeout="200" :default-active="$route[0]" mode="vertical">
            <el-submenu v-for="(route, index) in userPermission" :key="index" :index="index">
              <template slot="title">
                <i :class="`${route[0].pageIcon}`"></i>
                <span>{{route[0].pageMaster}}</span>
              </template>
              <el-menu-item
                v-for="(item, index) in route"
                :key="index"
                :index="item.pageLink"
              >{{item.pageName}}</el-menu-item>
            </el-submenu>
          </el-menu>
        </el-scrollbar>
  </div>
</template>
<script>
export default {
  data() {
    return {
      userPermission: ""
    };
  },
  beforeMount() {
    this.userPermission = JSON.parse(sessionStorage.getItem("userInfo")).pages;
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue